(() => {
  const params = new URLSearchParams(window.location.search);
  const referrerHost = (() => {
    try { return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; }
    catch { return ''; }
  })();
  const ownHosts = new Set(['rightprice.games', 'www.rightprice.games']);
  const attributionKey = 'rpg-storefront-attribution-v1';
  const visitorKey = 'rpg-anonymous-visitor-id-v1';
  const affiliateKey = 'rpg-affiliate-attribution-v1';
  const affiliateSyncKey = 'rpg-affiliate-cart-sync-v1';
  const affiliateEndpoint = 'https://right-pricer.weathered-water-e9b4.workers.dev/storefront/affiliate';
  const affiliateProfilesEndpoint = 'https://right-pricer.weathered-water-e9b4.workers.dev/storefront/affiliates';
  let attribution = null;
  try { attribution = JSON.parse(sessionStorage.getItem(attributionKey) || 'null'); } catch (_) {}
  const taggedSource = (params.get('utm_source') || '').trim().toLowerCase();
  if (taggedSource) {
    attribution = {
      source: taggedSource,
      medium: (params.get('utm_medium') || 'campaign').trim().toLowerCase(),
      campaign: (params.get('utm_campaign') || 'untagged').trim().toLowerCase(),
    };
  } else if (!attribution) {
    attribution = referrerHost && !ownHosts.has(referrerHost)
      ? { source: referrerHost, medium: 'referral', campaign: 'none' }
      : { source: 'direct', medium: 'none', campaign: 'none' };
  }
  try { sessionStorage.setItem(attributionKey, JSON.stringify(attribution)); } catch (_) {}

  let anonymousSessionId = '';
  try { anonymousSessionId = localStorage.getItem(visitorKey) || ''; } catch (_) {}
  if (!anonymousSessionId) {
    anonymousSessionId = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    try { localStorage.setItem(visitorKey, anonymousSessionId); } catch (_) {}
  }

  const cartAttributes = (affiliate) => ({
    'RPG Affiliate Code': affiliate?.code || '',
    'RPG Affiliate Clicked At': affiliate?.clickedAt || '',
    'RPG Affiliate Expires': affiliate?.expiresAt || '',
  });
  const syncAffiliateToCart = (affiliate) => {
    const signature = JSON.stringify(cartAttributes(affiliate));
    try { if (sessionStorage.getItem(affiliateSyncKey) === signature) return; } catch (_) {}
    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes(affiliate) }),
    }).then((response) => {
      if (!response.ok) throw new Error('Cart attribution failed');
      try { sessionStorage.setItem(affiliateSyncKey, signature); } catch (_) {}
    }).catch(() => {});
  };
  const installAffiliateStyle = () => {
    if (document.getElementById('rpg-affiliate-customer-style')) return;
    const style = document.createElement('style'); style.id = 'rpg-affiliate-customer-style';
    style.textContent = '.rpg-affiliate-customer{display:flex;align-items:center;gap:12px;margin:0 0 12px;padding:12px 14px;border:2px solid rgba(91,60,177,.28);border-radius:16px;background:rgba(247,243,252,.92);color:#32166b;text-align:left}.rpg-affiliate-customer img,.rpg-affiliate-customer__avatar{flex:0 0 48px;width:48px;height:48px;border-radius:50%;object-fit:cover;background:rgba(91,60,177,.12)}.rpg-affiliate-customer__avatar{display:grid;place-items:center;font-weight:900}.rpg-affiliate-customer span{display:grid;line-height:1.2}.rpg-affiliate-customer small{opacity:.75}.rpg-affiliate-customer strong{font-size:1rem}@media(prefers-color-scheme:dark){.rpg-affiliate-customer{border-color:rgba(205,189,255,.42);background:rgba(73,52,95,.96);color:#f8f3ff}}';
    document.head.appendChild(style);
  };
  const addAffiliateRecognition = (profile) => {
    installAffiliateStyle();
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      const region = button.closest('.cart-drawer__checkout-buttons') || button.parentElement;
      if (!region || region.querySelector('.rpg-affiliate-customer')) return;
      const card = document.createElement('div'); card.className = 'rpg-affiliate-customer'; card.setAttribute('role', 'status');
      if (profile.imageUrl) { const image = document.createElement('img'); image.src = profile.imageUrl; image.alt = ''; card.appendChild(image); }
      else { const avatar = document.createElement('span'); avatar.className = 'rpg-affiliate-customer__avatar'; avatar.textContent = (profile.name || '?').charAt(0).toUpperCase(); card.appendChild(avatar); }
      const copy = document.createElement('span'); const label = document.createElement('small'); label.textContent = 'Your affiliate'; const name = document.createElement('strong'); name.textContent = profile.name; copy.append(label, name);
      if (profile.subtitle) { const subtitle = document.createElement('small'); subtitle.textContent = profile.subtitle; copy.appendChild(subtitle); }
      card.appendChild(copy); region.insertBefore(card, region.firstChild);
    });
  };
  const loadAffiliateProfile = (code) => fetch(`${affiliateProfilesEndpoint}?code=${encodeURIComponent(code)}`, { mode: 'cors' })
    .then((response) => response.ok ? response.json() : Promise.reject(new Error('Affiliate profile unavailable')))
    .then(({ affiliates }) => { const profile = affiliates?.[0]; if (!profile) return; addAffiliateRecognition(profile); new MutationObserver(() => addAffiliateRecognition(profile)).observe(document.body, { childList: true, subtree: true }); })
    .catch(() => {});
  const storedAffiliate = (() => {
    try {
      const value = JSON.parse(localStorage.getItem(affiliateKey) || 'null');
      return value?.code && Date.parse(value.expiresAt) > Date.now() ? value : null;
    } catch (_) { return null; }
  })();
  const affiliateCode = (params.get('ref') || '').trim().toLowerCase();
  if (affiliateCode) {
    fetch(affiliateEndpoint, {
      method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ code: affiliateCode, anonymousVisitorId: anonymousSessionId, landingPath: window.location.pathname }),
    }).then((response) => response.ok ? response.json() : Promise.reject(new Error('Unknown affiliate')))
      .then(({ affiliate }) => {
        try { localStorage.setItem(affiliateKey, JSON.stringify(affiliate)); sessionStorage.removeItem(affiliateSyncKey); } catch (_) {}
        syncAffiliateToCart(affiliate);
        loadAffiliateProfile(affiliate.code);
      }).catch(() => {});
  } else if (storedAffiliate) { syncAffiliateToCart(storedAffiliate); loadAffiliateProfile(storedAffiliate.code); }
  else {
    try {
      if (localStorage.getItem(affiliateKey)) { localStorage.removeItem(affiliateKey); sessionStorage.removeItem(affiliateSyncKey); syncAffiliateToCart(null); }
    } catch (_) {}
  }

  const payload = JSON.stringify({
    source: attribution.source,
    medium: attribution.medium,
    campaign: attribution.campaign,
    anonymousSessionId,
    landingPath: window.location.pathname,
    referrerHost,
  });
  const endpoint = 'https://right-pricer.weathered-water-e9b4.workers.dev/storefront/visit';
  const queued = navigator.sendBeacon
    ? navigator.sendBeacon(endpoint, new Blob([payload], { type: 'text/plain;charset=UTF-8' }))
    : false;
  if (!queued) {
    fetch(endpoint, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: payload }).catch(() => {});
  }
})();
